import { Component, HostListener, OnInit, ViewChild } from "@angular/core";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { CoreService } from "../../services/core.service";
import { NgStyle, AsyncPipe } from "@angular/common";
@Component({
  selector: "app-messagepopup",
  templateUrl: "./MessagePopup.component.html",
  styleUrls: ["./MessagePopup.component.scss"],
  standalone: true,
  imports: [NgStyle, AsyncPipe],
})
export class MessagePopupComponent implements OnInit {
  @ViewChild("messageInfo", { static: false }) private messageInfo; // Reference to the messageInfo template

  currentBasket = this.coreService.currentBasket; // Current basket data
  Merchant$ = this.coreService.Merchant$; // Merchant data
  textMessage = ""; // Variable to hold the message to be displayed

  constructor(
    private coreService: CoreService,
    private modalService: NgbModal
  ) { }

  ngOnInit() {
    // Subscribe to the basket$ observable to get the current basket data
    this.coreService.basket$.subscribe((data) => {
      this.currentBasket = data;
    });
  }

  /**
   * Navigate to the About page.
   */
  GoToAbout() {
    this.coreService.navigateTo("/about");
  }

  /**
   * Open a popup with the specified message.
   * @param message The message to be displayed in the popup.
   */
  Openpopup(message: string) {
    // Options for the NgbModal
    let ngbModalOptions: NgbModalOptions = {
      backdrop: "static", // Prevent closing the popup by clicking outside
      centered: true,
      windowClass: "model",
      scrollable: true,
    };

    this.textMessage = message; // Set the message to be displayed
    this.modalService.open(this.messageInfo, ngbModalOptions); // Open the popup using the NgbModal service
  }

  /**
   * Listen to the 'popstate' event and dismiss all open modals when the user navigates back.
   * @param event The 'popstate' event object.
   */
  @HostListener("window:popstate", ["$event"])
  onPopState(event) {

    this.modalService.dismissAll(); // Dismiss all open modals
  }

  ngOnDestroy() {
    // Any cleanup logic can be added here when the component is destroyed
  }
}
